import { render, staticRenderFns } from "./JaliscoDoughutCharComponent.vue?vue&type=template&id=4334c1fc&scoped=true"
import script from "./JaliscoDoughutCharComponent.vue?vue&type=script&lang=js"
export * from "./JaliscoDoughutCharComponent.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/app.css?vue&type=style&index=0&id=4334c1fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334c1fc",
  null
  
)

export default component.exports